/* eslint-disable */
export class PermissionsMap {
  static mfb = 'mfb';

  static agent = ['home', 'wallet', 'buy-mpos', 'lending-applications', 'settings', 'user-profile', 'change-password', 'agent-onboarding', this.mfb];

  static aggregator = [...this.agent, 'agents-performance', 'agent-onboarding'];

  static headofcompliance = [...this.agent, 'aml', 'aml-setup', 'bvn-blacklist', 'statement', 'kyc-reporting', 'user-review', 'set-wallet-status'];

  static walletstatusupdater = ['aml', 'set-wallet-status', this.mfb];

  static kycapprover = ['aml', 'kyc-reporting', 'user-review', this.mfb];

  static kycreviewer = ['aml', 'kyc-reporting', 'user-review', this.mfb];

  static engineering = ['admin-tools', this.mfb];

  static support = [...this.agent, ...this.kycapprover, this.kycreviewer, 'statement', 'users', 'admin-tools', 'agent-profile', 'partners'];

  static insuranceops = ['reports', 'insurance-reports', 'products', 'insurance', this.mfb];

  static savingsops = ['reports', 'savings-reports', 'products', this.mfb];

  static lendingops = ['reports', 'lending-reports', 'products', 'loanrequests', 'pbs', 'pbrequests', 'npl', this.mfb];

  static operations = [
    ...this.agent,
    'reports',
    'savings-reports',
    'lending-reports',
    'insurance-reports',
    'products',
    'savings',
    'lending',
    'loanrequests',
    'pbs',
    'pbrequests',
    'npl',
    'users',
    'partners',
    'agent-profile',
    'insurance',
    'admin-tools',
  ];

  static savingssdk = ['home', 'wallet', 'user-profile', 'change-password', this.mfb];

  static humanresources = ['admin-tools', this.mfb];

  static lendinglead = ['loan-management-dashboard', this.mfb];

  static admin: (string | undefined)[] = [
    'mandate-card',
    ...this.lendinglead,
    ...this.humanresources,
    ...this.agent,
    ...this.aggregator,
    ...this.headofcompliance,
    ...this.operations,
  ];

  static removeDuplicates(arr: string[]) {
    return arr.filter((elm) => arr.indexOf(elm) === arr.lastIndexOf(elm));
  }
}

export type IPermissionsMapKeys =
  | 'agent'
  | 'aggregator'
  | 'headofcompliance'
  | 'kycapprover'
  | 'kycreviewer'
  | 'insuranceops'
  | 'savingsops'
  | 'lendingops'
  | 'operations'
  | 'support'
  | 'admin'
  | 'engineering'
  | 'walletstatusupdater'
  | 'humanresources'
  | 'lendinglead';
